import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';

const routes = [
  {
    path: '/',
    component: () => import('../layouts/MainLayout'),
    children: [
      {
        path: '',
        redirect: '/tasks'
      },
      {
        path: 'tasks',
        name: 'tasks',
        meta: { auth: true },
        component: () => import('../views/TasksView.vue')
      },
      {
        path: 'activity',
        name: 'activity',
        meta: { auth: true },
        component: () => import('../views/ActivityView.vue')
      },
      {
        path: 'settings',
        name: 'settings-view',
        meta: { auth: true },
        component: () => import('../views/SettingsView')
      },
      {
        path: 'books',
        name: 'books-view',
        meta: { auth: true },
        component: () => import('../views/BooksView')
      },
      {
        path: 'profile',
        name: 'profile',
        meta: { auth: true },
        component: () => import('../views/ProfileView')
      },
      {
        path: 'planner',
        name: 'planner',
        meta: { auth: true },
        component: () => import('../views/PlannerView')
      },
      {
        path: 'ideas',
        name: 'ideas',
        meta: { auth: true },
        component: () => import('../views/IdeasView')
      },
      {
        path: 'models',
        name: 'models',
        meta: { auth: true },
        component: () => import('../views/ModelsView')
      },
      {
        path: 'studies',
        name: 'studies',
        meta: { auth: true },
        component: () => import('../views/StudiesView')
      },
      {
        path: 'projects',
        meta: { auth: true },
        children: [
          {
            path: '',
            name: 'projects',
            component: () => import('../views/ProjectsView'),
          },
          {
            path: ':id',
            component: () => import('../layouts/ProjectLayout'),
            children: [
              {
                path: '',
                redirect: (to) => {
                  return { path: `/projects/${to.params.id}/details` };
                }
              },
              {
                path: 'details',
                name: 'project-details',
                meta: { auth: true },
                component: () => import('../views/ProjectDetails')
              },
              {
                path: 'user_testing',
                name: 'user-testing',
                meta: { auth: true },
                component: () => import('../views/ProjectUserTesting.vue')
              },
              {
                path: 'settings',
                name: 'project-settings',
                meta: { auth: true },
                component: () => import('../views/ProjectSettings')
              },
              {
                path: 'strategy',
                name: 'project-strategy',
                meta: { auth: true },
                component: () => import('../views/ProjectStrategy')
              },
              {
                path: 'planning',
                name: 'project-planning',
                meta: { auth: true },
                component: () => import('../views/ProjectPlanning')
              },
              {
                path: 'mvp',
                name: 'project-mvp',
                meta: { auth: true },
                component: () => import('../views/ProjectMvp')
              },
              {
                path: 'crms',
                name: 'project-crms',
                meta: { auth: true },
                component: () => import('../views/ProjectCrm')
              },
              {
                path: 'tech',
                name: 'project-tech',
                meta: { auth: true },
                component: () => import('../views/ProjectTech')
              },
              {
                path: 'decisions',
                name: 'project-decisions',
                meta: { auth: true },
                component: () => import('../views/ProjectDecisions')
              },
              {
                path: 'docs',
                name: 'project-docs',
                meta: { auth: true },
                component: () => import('../views/ProjectDocs')
              },
              {
                path: 'activities',
                name: 'project-activities',
                meta: { auth: true },
                component: () => import('../views/ProjectActivities')
              },
              {
                path: 'notes',
                name: 'project-notes',
                meta: { auth: true },
                component: () => import('../views/ProjectNotes')
              },
              {
                path: 'meetings',
                name: 'project-meetings',
                meta: { auth: true },
                component: () => import('../views/ProjectMeetings')
              },
              {
                path: 'participants',
                name: 'project-participants',
                meta: { auth: true },
                component: () => import('../views/ProjectParticipants')
              },
              {
                path: 'links',
                name: 'project-links',
                meta: { auth: true },
                component: () => import('../views/ProjectLinks')
              },
              {
                path: 'tasks',
                name: 'project-tasks',
                meta: { auth: true },
                component: () => import('../views/ProjectTasksView')
              }
            ]
          }
        ]
      },
      {
        path: 'roadmaps',
        name: 'roadmaps',
        meta: { auth: true },
        component: () => import('../views/Roadmaps_View')
      },
      {
        path: 'pitchdeck',
        name: 'pitchdeck',
        meta: { auth: true },
        component: () => import('../views/Pitchdeck_View')
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/register-success/:id/:email',
    name: 'register-success',
    component: () => import('../views/RegisterSuccess.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "about" */ '../views/404.vue')
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(async ({ params, meta, name: route }, from, next) => {
  if (route === 'login') {
    return next();
  }
  meta?.auth && !store.state.auth.user?.name
    ? await store.dispatch('get_user', next)
    : next();
});

export default router;
